import './App.css';
//
import { BrowserRouter as Router , Routes , Route } from 'react-router-dom';

// Screens
import Home from './Screens/Home';
import MyBlog from './Screens/myBlog/myBlog';
import { LebensLauf } from './Screens/lebenslauf/Lebenslauf';
import { Blogs } from './Screens/Blogs/Blogs';
import { Admin } from './Screens/Admin/Admin';


function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="*" element={<Home />} />
          <Route exact path="/blog" element={<MyBlog />} />
          <Route exact path="/cv" element={<LebensLauf />} />
          <Route exact path="/Blogs" element={<Blogs />} />
          <Route exact path="/Admin" element={<Admin />} />
        </Routes>
      </Router>
    </div>
    
  );
}

export default App;